<template>
  <div class="statis-teacher">
    <Form :model="searchCondition" :label-width="70" inline>
      <FormItem label="日期范围">
        <DatePicker
          ref="formDate"
          type="daterange"
          placeholder="选择日期范围"
          @on-change="onDateChange"
          style="width:200px;"
          :editable="false"
          clearable
        ></DatePicker>
      </FormItem>
      <FormItem :label-width="10">
        <Input
          v-model="searchCondition.keywords"
          placeholder="请输入关键字"
          style="width:250px;"
          clearable
          @keydown.native.prevent.enter="onSearch"
        >
          <Select v-model="searchCondition.keywords_type" style="width:90px;" slot="prepend">
            <Option v-for="item in keywordsType" :value="item.key" :key="item.key">{{item.value}}</Option>
          </Select>
        </Input>
      </FormItem>
      <FormItem class="search-form-btns">
        <div class="btn-wrap form-item-search">
          <Button icon="ios-search" @click="onSearch">搜索</Button>
          <Button icon="md-undo" @click="onReset">重置</Button>
        </div>
      </FormItem>
    </Form>
    <div>
      <Button type="primary" @click="onExport" class="btn-margin-right">批量导出</Button>
    </div>
    <div class="content">
      <Grid
        ref="grid"
        :columns="tableColumns"
        data-url="/api/teacher/statics"
        :search="searchCondition"
        selectType
        keyField="id"
        method="post"
      >
        <template slot-scope="{row}" slot="action">
          <div>
            <Button type="text" size="small" @click="onRecord(row)">授课记录</Button>
          </div>
        </template>
      </Grid>
    </div>
    <Modal v-model="modal.show" title="授课记录" width="800">
      <Form :model="modal.searchCondition" :label-width="70" inline>
        <FormItem label="课程类型">
          <Select v-model="modal.searchCondition.course_type" style="width:100px;" clearable>
            <Option
              v-for="item in modal.courseType"
              :value="item.key"
              :key="item.key"
            >{{item.value}}</Option>
          </Select>
        </FormItem>
        <FormItem :label-width="10" >
          <Input
            v-model="modal.searchCondition.keywords"
            placeholder="请输入关键字"
            style="width:250px;"
            clearable
          >
            <Select
              v-model="modal.searchCondition.keywords_type"
              style="width:90px;"
              slot="prepend"
            >
              <Option
                v-for="item in modal.keywordsType"
                :value="item.key"
                :key="item.key"
              >{{item.value}}</Option>
            </Select>
          </Input>
        </FormItem>
        <FormItem class="search-form-btns">
          <div class="btn-wrap form-item-search">
            <Button icon="ios-search" @click="onModalSearch">搜索</Button>
            <Button icon="md-undo" @click="onModalReset">重置</Button>
          </div>
        </FormItem>
      </Form>
      <div>
        <Button type="primary" @click="onExportRecord">批量导出</Button>
      </div>
      <div class="content">
        <Grid
          ref="modalGrid"
          :columns="modal.columns"
          :data-url="modal.dataUrl"
          :search="modal.searchCondition"
          :rowsFormatter="onModalRowsFormatter"
          selectType
          keyField="course_basis_id"
          method="post"
        ></Grid>
      </div>
    </Modal>
  </div>
</template>

<script>
import { CouseType } from "@/utils/enums";

export default {
  name: "statis-teacher",
  data() {
    return {
      searchCondition: {
        keywords_type: "name",
        keywords: "",
        created_at_start: "",
        created_at_end: "",
        init: function() {
          this.keywords_type = "name";
          this.keywords = "";
          this.created_at_start = "";
          this.created_at_end = "";
        }
      },
      keywordsType: [
        { key: "name", value: "讲师名称" },
        { key: "mobile", value: "手机号码" }
      ],
      tableColumns: [
        { title: "讲师名称", key: "real_name", minWidth: 120 },
        // { title: '讲师类型', key: 'teacher_type', align: 'center' },
        { title: "手机号码", key: "mobile", align: "center", minWidth: 120 },
        {
          title: "所授课程",
          key: "course_num",
          align: "center",
          minWidth: 100
        },
        { title: "总课时", key: "chapter_num", align: "center", minWidth: 100 },
        {
          title: "操作",
          slot: "action",
          align: "center",
          fixed: "right",
          minWidth: 120
        }
      ],
      modal: {
        show: false,
        columns: [
          { title: "课程名称", key: "title", minWidth: 150 },
          {
            title: "课程类型",
            key: "course_type_name",
            align: "center",
            minWidth: 120
          },
          {
            title: "总课时",
            key: "chapter_num",
            align: "center",
            minWidth: 100
          },
          {
            title: "已完成课时",
            key: "chapter_finish_num",
            align: "center",
            minWidth: 100
          },
          {
            title: "未完成课时",
            key: "chapter_unFinish_num",
            align: "center",
            minWidth: 100
          },
          {
            title: "总授课时长（分）",
            key: "teach_time",
            align: "center",
            minWidth: 100
          }
        ],
        dataUrl: "",
        searchCondition: {
          teacher_id: "",
          course_type: "",
          keywords_type: "title",
          keywords: "",
          init: function() {
            this.course_type = "";
            this.keywords_type = "title";
            this.keywords = "";
          }
        },
        courseType: CouseType.getOptions(),
        keywordsType: [
          { key: "title", value: "课程名称" }
        ]
      }
    };
  },
  methods: {
    onDateChange(range) {
      this.searchCondition.created_at_start = range[0];
      this.searchCondition.created_at_end = range[1];
    },
    onSearch() {
      this.$refs.grid.searchRefresh();
    },
    onReset() {
      this.searchCondition.init();
      this.$refs.formDate.handleClear();
      this.$refs.grid.searchRefresh();
    },
    onExport() {
      if (!this.$refs.grid.getTotal()) {
        this.$Message.info("暂无数据可导出");
        return;
      }
      this.$http
        .post("/api/teacher/statics/export", this.searchCondition)
        .then(data => {
          window.open(data.url);
        });
    },
    onExportRecord() {
      if (!this.$refs.modalGrid.getTotal()) {
        this.$Message.info("暂无数据可导出");
        return;
      }
      this.$http
        .post("/api/teacher/export", this.modal.searchCondition)
        .then(data => {
          window.open(data.url);
        });
    },
    onRecord(row) {
      this.modal.show = true;
      this.modal.searchCondition.teacher_id = row.id;
      this.modal.dataUrl = "/api/teacher/lesson";
      this.$nextTick(() => {
        this.$refs.modalGrid.searchRefresh();
      });
    },
    onModalRowsFormatter(rows) {
      rows.forEach(i => {
        i.course_type_name = CouseType.getValue(i.course_type);
      });
    },
    onModalSearch() {
      this.$refs.modalGrid.searchRefresh();
    },
    onModalReset() {
      this.modal.searchCondition.init();
      this.$refs.modalGrid.searchRefresh();
    }
  }
};
</script>

<style lang="" scoped>
</style>
